import React, { useEffect } from "react";
import { docs } from "../data/docs";
import { images } from "../data/images";
import { ReactComponent as EmailIcon } from "../content/icons/email.svg";
import { ReactComponent as LinkIcon } from "../content/icons/link.svg";
import { ReactComponent as ResumeIcon } from "../content/icons/resume.svg";

export default function About() {
  useEffect(() => {
  }, []);

  return (
    <div className="about-page">
      <div className="project-container">
        <div className="about-image-container">
          <picture>
            <source 
              media="(min-width: 1401px)" 
              srcSet={images.about[0]?.src || ''}
            />
            <source 
              media="(min-width: 1080px)" 
              srcSet={images.about[1]?.src || ''}
            />
            <source 
              media="(min-width: 741px)" 
              srcSet={images.about[2]?.src || ''}
            />
            <img 
              src={images.about[3]?.src || ''}
              alt="Photo collage showing Abby's life in New York" 
              className="about-image"
              onError={(e) => {
                console.error('Image failed to load:', {
                  currentSrc: e.target.currentSrc,
                  src: e.target.src,
                  images: images.about
                });
              }}
            />
          </picture>
        </div>
        <div className="project-description">
          <p>
            I'm a product designer who lives in Brooklyn. I'm currently a staff
            designer at Figma, where I work on activation and growth. Before that I
            designed at Lyft, Betterment, and creative agencies.
          </p>
          <p>
            My work is defined by a strong sense of craft and a focus on
            business impact. Lately, I've been having fun experimenting with AI
            tools and pushing the boundaries of what's possible for me to create
            on my own.
          </p>
          <p>
            When I'm not on my computer, you can find me walking, biking,
            reading, or spending time at the ceramics studio.
          </p>
        </div>
        <div className="contact-buttons">
          <a
            href="mailto:abbyjetmundsen@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            <EmailIcon className="button-icon" />
            Email
          </a>
          <a
            href={docs.resume}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            <ResumeIcon className="button-icon" />
            Resume
          </a>
          <a
            href="https://www.linkedin.com/in/abbyjetmundsen"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            <LinkIcon className="button-icon" />
            LinkedIn
          </a>
        </div>
      </div>
    </div>
  );
}